import { z } from 'zod';
import { SchemaDate, SchemaLocation, ZodArrayToEnum } from '@axiom/types';
import {
  estimatedDurationKeys,
  legalTeamSizeAllowedValues,
  levelOfExperienceAllowedValues,
  licensedLawyerAllowedValues,
  selfServiceAllowedCountryCodeValues,
  worksiteAllowedValues,
} from '@axiom/const';

export const AccountIntakeSchema = z.object({
  accountId: z.string().uuid(),
  additionalDetailsForTalent: z.string().nullish(),
  addressState: z.string().nullish(),
  addressCity: z.string().nullish(),
  addressZip: z.string().nullish(),
  addressStreet: z.string().nullish(),
  billingUnitsPerWeek: z.number(),
  billingUnitsPerDay: z.number(),
  businessTitle: z.string(),
  companyLocation: SchemaLocation.nullish(),
  contactId: z.string().uuid(),
  addressCountryCode: z
    .enum(ZodArrayToEnum(selfServiceAllowedCountryCodeValues))
    .nullable(),
  endDate: SchemaDate,
  estimatedDuration: z.enum(ZodArrayToEnum(estimatedDurationKeys)),
  generalSkills: z.array(z.string()).nullish(),
  industry: z.string().nullish(),
  instantMatchesRefreshedAt: SchemaDate,
  languageId: z.string().uuid().nullish(),
  legalSkills: z.array(z.string()).nullish(),
  legalTeamSize: z.enum(ZodArrayToEnum(legalTeamSizeAllowedValues)),
  legalTechSkills: z.array(z.string()).nullish(),
  levelOfExperience: z.enum(ZodArrayToEnum(levelOfExperienceAllowedValues)),
  licensedLawyer: z.enum(ZodArrayToEnum(licensedLawyerAllowedValues)),
  licensedLawyerState: z.string(),
  opportunityId: z.string().uuid(),
  otherFocusAreas: z.array(z.string()).nullish(),
  positionDescription: z.string(),
  practiceArea: z.string(),
  primaryFocusArea: z.string(),
  startDate: SchemaDate,
  urgency: z.string().nullish(),
  worksite: z.enum(ZodArrayToEnum(worksiteAllowedValues)),
});

export type AccountIntake = z.infer<typeof AccountIntakeSchema>;
